import PropTypes from "prop-types";
import { InputSelect } from "../../components/formComponents/inputSelect";
import { formatRUT } from "../../utils/funciones";

export const ColaboradorResumen = ({ arrData, filtrarUno, uno, formatFecha, objTipoContrato }) => {
  return (
    <div className="col col-11 col-lg-10 col-xl-10">
      <div
        className="bg-white mb-4"
        style={{
          borderRadius: "8px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid #e0e0e0",
          position: "relative",
          zIndex: 5,
        }}
      >
        {/* Header Selector Colaborador */}
        <div className="d-flex flex-row justify-content-between align-items-center p-3 px-4">
          <span className="fw-bold text-dark m-0 align-self-center" style={{ fontSize: "18px", lineHeight: "1" }}>
            Seleccionar Colaborador
          </span>
          <div className="d-flex align-items-center" style={{ width: "50%", maxWidth: "500px" }}>
            <InputSelect
              label="xxx"
              placeholder="--Seleccione colaborador--"
              llave_texto="REEO_NOMBRE_COMPLETO"
              llave_valor="REEO_CODIGO_SAP"
              arr={arrData}
              ejecute={filtrarUno}
              id="select_Colaborador"
              clases="w-100"
            />
          </div>
        </div>

        {/* Tabla Colaborador Seleccionado */}
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0" style={{ borderCollapse: "collapse", tableLayout: "fixed", width: "100%" }}>
            <thead>
              <tr style={{ backgroundColor: "#2472BA", color: "#ffffff" }}>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "13%" }}>RUT</th>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>ID PERSONAL</th>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>POS. ACTUAL</th>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "27%" }}>CARGO ACTUAL</th>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>JORNADA/PHTD</th>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>FECHA ALTA</th>
                <th className="py-2.5 px-3 fw-bold border-0" style={{ backgroundColor: "#2472BA", color: "#fff", fontSize: "13.5px", width: "12%" }}>TIPO CONTRATO</th>
              </tr>
            </thead>
            <tbody id="body-tabla">
              {uno === undefined ? (
                <tr style={{ backgroundColor: "#fff", height: "48px" }}>
                  <td colSpan={7} className="py-3 px-3 border-0 text-center text-muted fw-bold" style={{ fontSize: "13.5px" }}>
                    Aún no se selecciona colaborador
                  </td>
                </tr>
              ) : (
                <tr style={{ fontSize: "13.5px", color: "#333", backgroundColor: "#fff", height: "48px" }}>
                  <td className="py-3 px-3 border-0 text-truncate">{formatRUT(uno.REEO_RUT)}</td>
                  <td className="py-3 px-3 border-0 text-truncate">{uno.REEO_CODIGO_SAP}</td>
                  <td className="py-3 px-3 border-0 text-truncate">{uno.REEO_CODIGO_POSICION}</td>
                  <td className="py-3 px-3 border-0 text-truncate" title={uno.estructura?.MOES_DESCRIPCION_POSICION}>{uno.estructura?.MOES_DESCRIPCION_POSICION}</td>
                  <td className="py-3 px-3 border-0 text-truncate">{uno.REEO_PLAN_HORARIO}</td>
                  <td className="py-3 px-3 border-0 text-truncate">{formatFecha(uno.REEO_FECHA_INICIO_CONTRATO)}</td>
                  <td className="py-3 px-3 border-0 text-truncate">{objTipoContrato[uno.REEO_TIPO_CONTRATO]}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

ColaboradorResumen.propTypes = {
  arrData: PropTypes.array,
  filtrarUno: PropTypes.func.isRequired,
  uno: PropTypes.object,
  formatFecha: PropTypes.func.isRequired,
  objTipoContrato: PropTypes.object.isRequired,
};
